export enum PageTab {
  Templates = 'templates',
  Active = 'active',
  Archived = 'archived'
}
